import { Injectable } from '@angular/core';
import { Question } from '../../models/Question';
import { Interview } from '../../models/Interview';
import { Attempt } from '../../models/Attempt';
import {PicklistValue} from '@symplicity/syng';

@Injectable()
export class FactoryService {

    constructor() {}

    questionsFactory(dto): Question {
        if (dto) {
            return new Question(
                dto['question_id'],
                dto['question_file'],
                dto['question_text'],
                dto['response_duration'],
            );
        }
        return null;
    }

    interviewFactory(dto): Interview {
        if (dto) {
            return new Interview (
                dto['title'],
                dto['questions'],
                dto['attempts'],
                dto['student']
            );
        }
        return null;
    }

    attemptsFactory(dto): Attempt {
        if (dto) {
            return new Attempt (
                dto['video_interview_id'],
                dto['status'],
                dto['student'],
                dto['created'],
                dto['modified'],
                dto['questions'],
                dto['video_interview']
            );
        }
        return null;
    }

    picklistValueFactory(dto): PicklistValue {
        if (dto) {
            return new PicklistValue(
                dto['id'] || dto['_id'],
                dto['value'] || dto['_label']
            );
        }
        return null;
    }

    picklistValuesFactory(dto): PicklistValue[] {
        if (dto) {
            return dto.map(pick => this.picklistValueFactory(pick));
        }
        return null;
    }
}
